var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header-logo" }, [
    _vm.h1
      ? _c("h1", { staticClass: "header-logo__heading" }, [
          _c("a", { staticClass: "header-logo__image", attrs: { href: "/" } }, [
            _c("img", {
              attrs: { src: _vm.image, srcset: _vm.imageSource, alt: _vm.alt }
            }),
            _c("span", { staticClass: "u-hidden" }, [_vm._v(_vm._s(_vm.alt))])
          ])
        ])
      : _c("div", [
          _c("a", { staticClass: "header-logo__image", attrs: { href: "/" } }, [
            _c("img", {
              attrs: { src: _vm.image, srcset: _vm.imageSource, alt: _vm.alt }
            })
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }